<div *ngIf="content" [innerHTML]="content | safe_html" class="label-container"></div>
